import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { ControlPoint } from '../../models/controlPoint';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EventData } from '../../../features/vibration-events/models/event-data';
import { VibrationsChart } from '../../models/charts/VibrationsChart';
import { ControlPointsService } from '../../../features/control-points/services/control-points-service';
import { EventService } from '../../../features/vibration-events/services/event-service';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { SelectOption } from '../../models/select-option';
import { FonctionsService } from '../../services/utilities/fonctions.service';
import { VibrationsRecordService } from '../../services/records/vibrations-record.service';
import { SitesHttpService } from '@shared/services/http/sites-http.service';
import { Site } from '@shared/models/site';
import { VibrationRecord } from '@shared/models/vibration-record';
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from '@shared/services/utilities/local-storage.service';


@Component({
  selector: 'app-records-assignment',
  imports: [CommonModule, FormsModule, AutocompleteComponent, TranslateModule],
  templateUrl: './records-assignment.component.html',
  styleUrl: './records-assignment.component.scss',
})

export class RecordsAssignmentComponent implements OnInit {
  constructor(
    private fonctionsService: FonctionsService,
    private eventService: EventService,
    private vibrationRecordService: VibrationsRecordService,
    private siteServcie: SitesHttpService,
    private controlPointService: ControlPointsService,
    private localStorageService: LocalStorageService,
    private cdRef: ChangeDetectorRef
  ) { }




  optionsControlPoints: SelectOption[] = [];
  selectedOptionCp: SelectOption;
  public placeholderCp: string = 'Select a control Point';

  optionsEvents: SelectOption[] = [];
  selectedOptionEvent: SelectOption;
  public placeholderEvent: string = 'Select a source';
  site: Site;
  recordSite: Site;
  siteName:any;
  allSites: Site[] = [];
  optionsSites: SelectOption[] = [];
  selectedSite: Site | null = null;


  @Input() siteId: number;
  @Input() isEventAssigned: boolean = false;
  @Input() isControlPointAssigned: boolean = false;
  @Input() isdeviceAssigned: boolean = false;

  @Input() eventdata: EventData;
  @Input() vibrationRecord: VibrationsChart;

  filterControlPoint: string = '';
  filteredCpList: ControlPoint[] = [];
  @Input() controlPoints: ControlPoint[] = [];


  filterEvent: string = '';
  filteredEventList: EventData[] = [];
  @Input() events: EventData[] = [];


  filterDevice: string = '';
  filteredDeviceList: ControlPoint[] = [];
  assignedControlPoint: ControlPoint;
  assignedEvent: EventData;
  url: string = '';
  @Input() deviceRef: string;


  ngOnInit(): void {
    this.allSites = this.localStorageService.getItem('allSites') || [];
    this.optionsSites = this.allSites.map(site => ({
      id: site.siteId,
      name: site.nom
    }));
    this.loadSite();
    this.getControlPointsBySite(this.siteId);
    this.getEventsBySite(this.siteId);
    this.url = window.location.href;
    this.siteServcie.getSitesAcitve().subscribe((site) => {
      this.site = site.find(s => s.siteId == this.siteId);
    })
  }
  loadSite(): void {
    this.siteServcie.getSitesAcitve().subscribe((sites) => {
      this.site = sites.find(s => s.siteId == this.siteId);
      this.recordSite = sites.find(s => s.siteId === this.vibrationRecord?.siteId);
    })

  }

  filterListEvent() {
    if (this.filterEvent) {
      this.filteredEventList = this.events.filter(event =>
        event.name.toLowerCase().includes(this.filterEvent.toLowerCase())
      );
    } else {
      this.filteredEventList = [...this.events];
    }
  }

  modifyAssignedEvent() {
    this.isEventAssigned = !this.isEventAssigned;
  }

  modifyAssignedCp() {
    this.isControlPointAssigned = false;
    const recordSite = this.allSites.find(s => s.siteId === this.vibrationRecord?.siteId);
    if (recordSite) {
      this.controlPointService.getControlPointsBySiteId(recordSite.siteId, false).subscribe(controlPoints => {
        this.controlPoints = controlPoints;
        this.optionsControlPoints = controlPoints.map(cp => ({
          id: cp.controlPointId,
          name: cp.name
        }));
        this.cdRef.detectChanges();
      });
    }
  }

  cancel(type: string) {
    if (type === 'event') {
      this.isEventAssigned = true;
    }
    if (type === 'controlPoint') {
      this.isControlPointAssigned = true;
    }
  }

  getControlPointsBySite(siteId: number): void {
    if(!this.controlPoints){
      return;
    }

    if (this.vibrationRecord.controlPointId) {
      this.assignedControlPoint = this.controlPoints?.find(cp => cp.controlPointId === this.vibrationRecord.controlPointId);
      this.cdRef.detectChanges();
    }

    this.optionsControlPoints = this.controlPoints?.map(cp => {
      return {
        id: cp.controlPointId,
        name: cp.name
      }

    });

  }

  getEventsBySite(siteId: number): void {
    this.eventService.getVibrationEvents(siteId, null)
      .subscribe((response) => {
        this.events = response.data;
        if (this.events && this.events.length > 0) {
          this.assignedEvent = this.events.find(evt => evt.id === this.vibrationRecord.eventId);
          this.optionsEvents = this.events.map(evt => ({
            id: evt.id,
            name: evt.name
          }));
        }
      });
  }

  onOptionCpSelected(option: SelectOption): void {
    this.selectedOptionCp = option;
  }

  onOptionSiteSelected(option: SelectOption | null): void {
    this.selectedOptionCp = null;
    this.optionsControlPoints = [];

    if (option && option.id) {
      this.selectedSite = this.allSites.find(site => site.siteId === option.id) || null;
      if (this.selectedSite) {
        this.controlPointService.getControlPointsBySiteId(this.selectedSite.siteId, true).subscribe(controlPoints => {
          this.controlPoints = controlPoints;
          this.optionsControlPoints = controlPoints.map(cp => ({
            id: cp.controlPointId,
            name: cp.name
          }));
          this.cdRef.detectChanges();
        });
      }
    } else {
      this.selectedSite = null;
      this.controlPoints = [];
      this.cdRef.detectChanges();
    }
  }

  onOptionEventSelected(option: SelectOption): void {
    this.selectedOptionEvent = option;
  }

  assignRecord(type: string): void {
    let isEvent = type === 'event';
    let isControlPoint = type === 'controlPoint';

    let successMessage = isEvent ? 'Source successfully assigned' : 'Measurement point successfully assigned';
    let errorMessage = isEvent ? 'Error assigning source' : 'Error assigning measurement point';

    if (isControlPoint && !this.selectedOptionCp) {
      this.fonctionsService.launch_toast(false, 'Please select a measurement point to assign');
      return;
    }

    if (isEvent && !this.selectedOptionEvent) {
      this.fonctionsService.launch_toast(false, 'Please select a source to assign');
      return;
    }

    if (isControlPoint) {
      this.vibrationRecord.controlPointId = this.selectedOptionCp.id;
      this.vibrationRecord.controlPointName = this.selectedOptionCp.name;
    }

    if (isEvent) {
      this.vibrationRecord.eventId = this.selectedOptionEvent.id;
    }
    this.vibrationRecord.siteId = this.selectedSite ? this.selectedSite.siteId : this.vibrationRecord.siteId;
    let data: VibrationRecord = {
      information: {
        currentURL: window.location.href,
        regionName: this.site.region?.nom,
        siteName: this.site.nom,
        controlPointName: this.selectedOptionCp?.name
      },
      vibrationRecord: this.vibrationRecord
    }
    this.vibrationRecordService.updateRecord(this.siteId, this.vibrationRecord.id.toString(), data).subscribe({
      next: () => {
        if (isControlPoint) {
          this.assignedControlPoint = this.controlPoints.find(cp => cp.controlPointId === this.selectedOptionCp.id);
          this.recordSite = this.allSites.find(s => s.siteId === this.vibrationRecord.siteId);
        }
        if (isEvent) {
          this.eventdata = this.events.find(evt => evt.id === this.selectedOptionEvent.id);
        }
        this.isControlPointAssigned = true;
        this.fonctionsService.launch_toast(true, successMessage)
        this.cdRef.detectChanges();
      },
      error: (err: any) => {
        this.fonctionsService.launch_toast(false, errorMessage);
      }
    });
  }

  unassignRecord(type: string): void {

    let isEvent = type === 'event';
    let isControlPoint = type === 'controlPoint';

    let successMessage = isEvent ? 'Source successfully unassigned' : 'Control point successfully unassigned';
    let errorMessage = isEvent ? 'Error unassigning source' : 'Error unassigning control point';

    if (isControlPoint) {
      this.vibrationRecord.controlPointId = 0;
    }

    if (isEvent) {
      this.vibrationRecord.eventId = 0;
    }
    let data: VibrationRecord = {
      information: {
        currentURL: window.location.href,
        regionName: this.site.region?.nom,
        siteName: this.site.nom,
        controlPointName: ''
      },
      vibrationRecord: this.vibrationRecord
    }

    this.vibrationRecordService.updateRecord(this.siteId, this.vibrationRecord.id.toString(), data).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true, successMessage);
      },
      error: (err: any) => {
        console.error(errorMessage, err);
      }
    });
  }
}